'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var ndjson = require('iterable-ndjson');

var toIterable = require('stream-to-it/source');

var encodeBufferURIComponent = require('../lib/encode-buffer-uri-component');

var configure = require('../lib/configure');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, message;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              if (options.verbose != null) searchParams.set('verbose', options.verbose);

              if (Buffer.isBuffer(key)) {
                _context.next = 5;
                break;
              }

              throw new Error('invalid key');

            case 5:
              _context.next = 7;
              return ky.post("dht/get?key=".concat(encodeBufferURIComponent(key), "&").concat(searchParams), {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers
              });

            case 7:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 10;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 12:
              _context.next = 14;
              return _iterator.next();

            case 14:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 18;
              return _step.value;

            case 18:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 28;
                break;
              }

              message = _value;

              if (!(message.Type === 3)) {
                _context.next = 23;
                break;
              }

              throw new Error(message.Extra);

            case 23:
              if (!(message.Type === 5)) {
                _context.next = 25;
                break;
              }

              return _context.abrupt("return", message.Extra);

            case 25:
              _iteratorNormalCompletion = true;
              _context.next = 12;
              break;

            case 28:
              _context.next = 34;
              break;

            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 34:
              _context.prev = 34;
              _context.prev = 35;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 39;
                break;
              }

              _context.next = 39;
              return _iterator.return();

            case 39:
              _context.prev = 39;

              if (!_didIteratorError) {
                _context.next = 42;
                break;
              }

              throw _iteratorError;

            case 42:
              return _context.finish(39);

            case 43:
              return _context.finish(34);

            case 44:
              throw new Error('not found');

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 30, 34, 44], [35,, 39, 43]]);
    }));

    function get(_x, _x2) {
      return _get.apply(this, arguments);
    }

    return get;
  }();
});